import * as React from 'react';

import { TJsonQuery } from '../../../JsonQuery';
import { IJsonQuery } from '../../../api-models/common/json_query';
import { IExperimentalFeatures } from '../types/filters';
import { TModifier } from '../types/modifier';
import { ISpecialPromo } from '../types/specialPromo';

export interface IContext {
  jsonQuery: IJsonQuery;
  specialPromo?: ISpecialPromo;
  features: IExperimentalFeatures;
  onChange(...modifiers: [TModifier, ...TModifier[]]): TJsonQuery;
  onApply(): void;
  onClear?(): void;
  onApplyClick?(): void;
  onAdvancedFiltersOpen?(): void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const context = React.createContext<IContext>(null as any);
